









































































import Vue from "vue";
import Component from "vue-class-component";
import Page from "@/components/layout/page.vue";
import UserSelector from "@/components/pickers/user-selector.vue";
import { Watch } from "vue-property-decorator";
import DateRangePicker from "@/components/pickers/date-range-picker.vue";
import { DateTime } from "luxon";
import DataTable from "@/components/data/data-table.vue";
import { DataTableField } from "@/components/data/data-table";
import { contactTraceService } from "@/services/contact-trace";
import { unparse } from "papaparse";
import { ContactTraceResult } from "@/swagger/models";

@Component({
    name: "report-contact-trace",
    components: { DataTable, DateRangePicker, UserSelector, Page },
})
export default class ReportContactTrace extends Vue {
    userId: number = null;
    range: DateTime[] = [DateTime.local().minus({ days: 1, weeks: 1 }), DateTime.local().minus({ days: 1 })];
    loading: boolean = false;

    results: any[] = [];
    fields: DataTableField<ContactTraceResult>[] = [
        {
            label: "User",
            field: "user",
        },
        {
            label: "Severity",
            field: "severity",
        },
        {
            label: "Reason",
            field: "reason",
        },
        {
            label: "Date",
            field: "date",
            format: (date: string) => DateTime.fromISO(date).toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY),
        },
    ];

    @Watch("userId")
    @Watch("range")
    async updateResults() {
        try {
            // console.log("Running trace from user", this.userId, this.range);
            if (!this.userId) return;

            this.loading = true;
            this.results = (
                await contactTraceService.find({
                    params: {
                        userId: this.userId,
                        startDate: this.range[0].toISODate(),
                        endDate: this.range[1].toISODate(),
                    },
                })
            ).sort((r1, r2) => (r1.severity > r2.severity ? -1 : 1));
        } catch (e) {
            console.warn(e);
        } finally {
            this.loading = false;
        }
    }

    async exportToCSV() {
        const csv = unparse(this.results);

        // Yay javascript
        const element = document.createElement("a");
        element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(csv));
        element.setAttribute(
            "download",
            `contact-trace-${this.userId}-${this.range[0].toLocaleString(
                DateTime.DATE_SHORT,
            )}-${this.range[0].toLocaleString(DateTime.DATE_SHORT)}.csv`,
        );
        element.style.display = "none";
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }
}
